import { ReservationDto } from '@wwt/entities/api/search-response'

import { api } from '@/shared/api/client'

export const getVoucherQuery = async (
	reservationId: ReservationDto['reservationId'],
	signal: AbortSignal
) => {
	const response = await api('blob')
		.options({ signal })
		.get(`/v1/reservation/voucher/${reservationId}`)
		.blob()

	return response
}
